import { gql } from "@/graphql/typed-gql"

/**
 * Hand the device to a learner. One call, no confirmation — going in is meant to
 * be effortless. The server swaps the auth cookie, so the caller must reload.
 */
export const ENTER_KID_MODE = gql`
  mutation EnterKidMode($studentId: ID!) {
    enterKidMode(studentId: $studentId) {
      success
      student {
        id
        name
      }
      errors
    }
  }
`

/** Trade the parent PIN for the guardian session. */
export const EXIT_KID_MODE = gql`
  mutation ExitKidMode($pin: String!) {
    exitKidMode(pin: $pin) {
      success
      error
      retryAfterSeconds
    }
  }
`

export const SET_PARENT_PIN = gql`
  mutation SetParentPin($pin: String!, $currentPin: String) {
    setParentPin(pin: $pin, currentPin: $currentPin) {
      success
      error
    }
  }
`
